import { ReactNode } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
} from '@rossum/ui/material';
import DialogTitle from '../dialog-title/DialogTitle';

export type SelectDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;

  title: string;
  submitText: string;
  cancelText: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  tertiaryAction?: JSX.Element;
  children: ReactNode;
};

export const ChoiceDialog = ({
  open,
  onClose,
  onConfirm,
  isLoading,
  isDisabled,
  title,
  submitText,
  cancelText,
  tertiaryAction,
  children,
}: SelectDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        elevation: 2,
        sx: { width: 450, height: 500 },
      }}
    >
      <DialogTitle title={title} onClose={onClose} />
      <DialogContent sx={{ mt: 2 }}>{children}</DialogContent>

      <DialogActions sx={{ flexGrow: 0, justifySelf: 'right', p: 2 }}>
        {tertiaryAction}
        <Button
          variant="outlined"
          color="secondary"
          onClick={onClose}
          data-cy="choice-dialog-cancel-btn"
        >
          {cancelText}
        </Button>
        <Button
          variant="contained"
          disabled={isDisabled || isLoading}
          startIcon={
            isLoading ? <CircularProgress color="inherit" size={16} /> : null
          }
          onClick={() => {
            onConfirm();
          }}
          data-cy="choice-dialog-submit-btn"
        >
          {submitText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
